/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  commonConfig.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter, assignParams} from "./index";
import {ShopGoodsListDto} from "@/api/shoppingMall";

/* 数据字典数据类型 */
export class DictDataDto {
    dataId: string;
    dataName: string;
    dictTypeId: string;
    sysRecordIndex: number
}

export class FileDTO {
    type?: string;
    file?: File;
    status?: string;
    autoId?: string;
    fileName?: string;
    fileUrl?: string;
    filePath?: string;
    fileSize?: number;
    fileSizeUnit?: string;
    fileBase64?: string;
    fileType?: string;
    url?: string
}

export const fileTypes: any = {
    log: 1, // 公司log
    goodsBanner: 2, // 商品轮播图
    goodsRecommend: 3, // 商品推荐图
    goodsVideo: 4, // 商品视频
    goodsHtml: 5, // 商品内容HTML文件
    orderFile: 6, // 订单附件
    noticeFile: 7, // 公司公告附件
    idCard: 8, // 身份证
    businessLicense:9 //营业执照
  }

/**
 * 获取配置信息
 * @param parameter
 */
export function getSyDictDataInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<DictDataDto[]>>({
        url: "/cykjorder/OS/getSyDictDataInfo",
        method: "get",
        params: parameter,
        extraParams: {
            showLoading: false
        }
    });
}

/* 上传附件返回的数据类型 */
export class AppendixFileDto {
    /* 附件路径 */
    orderFileUrl?: string;
    /* 附件名称 */
    orderFileName?: string;
    /* 附件大小 */
    orderFileSize?: string;
    /* 附件类别 */
    fileType?: string;
  /* 附件id */
    attachmentId?:string
    /* 上传人id */
    createUser?: string;
    // 上传路径
    filePath?:string
    // 上传大小
    fileSize?:string
    // 上传名称
    fileName?:string
}

/**
 * 文件上传
 * @param parameter
 */
export function upFile(parameter: Parameter = {}) {
    parameter.append('companyId', assignParams().companyId)
    return axiosAPIUrl<Ajax.Response<AppendixFileDto>>({
        url: "/cykjcommodity/goodsGM/upFile",
        method: "post",
        data: parameter
    });
}

/**
 * 文件下载
 * @param parameter
 */
export function downloadFile(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/goodsGM/downloadFile",
        method: "get",
        params: parameter,
        responseType: "arraybuffer",
    });
}

/* 服务热线列表数据类型 */
export class ServiceLineListDto {
    lineName?: string;
    linePhone?: string;
}

/**
 * 获取公司服务热线
 * @param parameter
 */
export function getCompanyLine(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ serviceLineList?: ServiceLineListDto[] }>>({
        url: "/cykjoperation/companyQuery/getCompanyLine",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: false
        }
    });
}

// 公司账户返回数据类型
export class AccountInfoDto {
    companyId?: string;
    accountList?: AccountInfoListApi[]
}

export class AccountInfoListApi {
    accountName?: string;
    accountBank?: string;
    accountId?: string;
    autoId?: string;
}

/* 获取银行账卡信息 */
export function getCompanyAccountInfo (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<AccountInfoDto>>({
        url: "/cykjoperation/companyQuery/getCompanyAccountInfo",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: false
        }
    });
}

export class ValetCustomerListDto {
    companyId?: string;
    customerName?: string;
    customerLever?: string;
    customerLeverName?: string;
    linePhone?: string
}

/* 查询代客客户列表 */
export function getValetCustomerList (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ValetCustomerListDto>>>({
        url: "/cykjorder/OM/getValetCustomerList",
        method: "post",
        data: parameter,
    });
}

/* 分类下可选下单商品列表 */
export class GoodsListOfCategoryDto {
    goodsId?: string;
    versionId?: string;
    goodsName?: string;
    goodsSortNum?: number;
    brandId?: string;
    brandName?: string;
    imageNameUrl?: string;
    goodsMainImage?: string;
    // 1 上架,2 下架,3 停用,4 删除
    goodsStatus?: number;
    categoryId?: string;
    categoryName?: string;
    keyword?: string;
    goodsTagList?: { tagId?: string; tagName?: string; tagColor?: string; }[];
    packageList?: GoodsPackageOfCategoryDto[];
}

export class GoodsListOfCategoryFormatDto extends GoodsListOfCategoryDto {
    packageId?: string;
    packageName?: string;
    packageNameDesc?: string;
    imageNameUrl?: string;
    orderPrice?: number;
    minimum?: number;
    maximum?: number;
    saleAmount?: number;
}

/* 套餐列表 */
export class GoodsPackageOfCategoryDto {
    packageId?: string;
    packageName?: string;
    packageNameDesc?: string;
    packageCode?: string;
    mainImageUrl?: string;
    /* 套餐主图Size */
    mainImageSize?: number;
    /* 市场价 */
    marketPrice?: number;
    /* 参考成本价 */
    referPrice?: number;
    barcode?: string;
    weight?: number;
    /* orderPrice */
    orderPrice?: number;
    minimum?: number;
    maximum?: number;
}

/* 获取分类下可选下单商品列表 */
export function getGoodsListOfCategoryAPI (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsListOfCategoryDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getGoodsListOfCategory",
        method: "post",
        data: parameter,
    });
}

/* 获取代客下单可选商品列表 */
export function getMerchantsGoodsList (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsListOfCategoryDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getMerchantsGoodsList",
        method: "get",
        params: parameter,
    });
}

/* 扫码获取商品列表信息 */
export function getGoodsListByBarcode (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsListOfCategoryDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getGoodsListByBarcode",
        method: "get",
        params: parameter,
    });
}

export class SelectGoodsPackageListDto {
    packageId?: string;
    packageName?: string;
    packageNameDesc?: string;
    packageCode?: string;
    mainImageUrl?: string;
    mainImageSize?: string;
    marketPrice?: number;
    referPrice?: number;
    barcode?: string;
    weight?: number;
    orderPrice?: number;
    minimum?: number;
    maximum?: number;
}

/* 选择商品页选中到购物车中商品列表数据类型 */
export class SelectGoodsOptionsDto extends SelectGoodsPackageListDto{
    goodsId?: string;
    goodsName?: string;
    imageNameUrl?: string;
    versionId?: string;
    saleAmount?: number;
}

/*  扫码获取商品列表信息 */
export function getGoodsByBarcode (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopGoodsListDto[]>>({
        url: "/cykjenterprise/shopGoods/sg007",
        method: "get",
        params: parameter,
    });
}

/*  存储错误日志 */
export function saveFrontLog (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjLog/log/frontlog",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: false,
        }
    });
}

/*  获取消息未读条数 */
export function getUnreadInfoCount (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjmessage/messageCenter/getUnreadInfoCount",
        method: "get",
        params: parameter,
        extraParams: {
            showLoading: false,
        }
    });
}

/* 注销账户 */
export function DelEmployee (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjusercenter/usermanagement/web/DelEmployee",
        method: "post",
        data: parameter
    });
}

/* 添加附件 */
export function addAttachment (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/attachment/addAttachment",
    method: "post",
    data:{...parameter, ...assignParams()}
  });
}

/* 删除附件 */
export function delAttachment (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjorder/attachment/delAttachment",
    method: "post",
    data: parameter,
  });
}

/* 1.26 查询金融服务模块授信到期时间 */
export function getUserOtherInfoFCD (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjoperation/companyManage/getUserOtherInfoFCD",
    method: "get",
    params: parameter,
  });
}

/* 1.25 更新用户金融服务模块授信到期时间 */
export function updateUserOtherInfoFCD (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjoperation/companyManage/updateUserOtherInfoFCD",
    method: "post",
    data: parameter,
  });
}
